import { dynamicImports } from "../../../Core/DynamicImports";
import { pluginsApi } from "@/Api/Plugins";
import { PopupVariant, } from "@/UI/MessageAlerts/Popups/InterfacesAndEnums";
/**
 * Setup error reporting.
 */
export function errorReportingSetup() {
    /**
     * Catch unhandled errors.
     *
     * @param {string} message  The error message.
     * @param {string} source   The source.
     * @param {number} lineno   The line number.
     * @param {number} colno    The column number.
     * @param {Error}  error    The error.
     */
    window.onerror = function (message, source, lineno, colno, error) {
        const data = {
            message: message,
            source: source,
            lineno: lineno,
            colno: colno,
            errorStack: error ? error.stack : null,
        };
        sendErrorToServer(data);
        // rethrow the error (not necessary)
        // throw error;
    };
}
/**
 * Catch unhandled promise rejections.
 *
 * @param {PromiseRejectionEvent} event  The event.
 */
window.onunhandledrejection = function (event) {
    let message = "An unknown promise rejection occurred.";
    let stack = "";
    if (event.reason) {
        if (event.reason instanceof Error) {
            message = event.reason.message;
            stack = event.reason.stack || "";
        }
        else {
            message = String(event.reason);
        }
    }
    sendErrorToServer({
        message: message,
        errorStack: stack,
    });
};
let tmpErrorMsg = "";
/**
 * Set a temporary error message. Occasionally, I can detect that an error is
 * about to come (e.g., when trying to dock a molecule that has not been
 * desaulted). It is tricky to fully catch these WASM errors, but I can control
 * the message at least.
 *
 * @param {string} msg  The message.
 * @param {number} duration  How long this tmp error message is valid.
 */
export function setTempErrorMsg(msg, duration = 2000) {
    tmpErrorMsg = "TMPERRORMSG:" + msg;
    setTimeout(() => {
        tmpErrorMsg = "";
    }, duration);
}
/**
 * Send error data to the server if user has authorized.
 *
 * @param {IErrorData} errorData  The error data.
 */
async function sendErrorToServer(errorData) {
    // errorData["molecules"] = getMoleculesFromStore().serialize();
    let txt = "";
    // If there is a message, add it to the txt
    if (errorData["message"]) {
        txt += `${errorData["message"]}\n`;
    }
    // If source
    if (errorData["source"]) {
        txt += `${errorData["source"]}\n`;
    }
    // lineno, colno
    if (errorData["lineno"]) {
        txt += `Line: ${errorData["lineno"]}\n`;
    }
    if (errorData["colno"]) {
        txt += `Column: ${errorData["colno"]}\n`;
    }
    // If there is an error stack, add it to the txt
    if (errorData["errorStack"]) {
        txt += `${errorData["errorStack"]}\n`;
    }
    // If there are molecules, add them to the txt
    if (errorData["molecules"]) {
        txt += "Molecules:\n";
        for (const molecule of errorData["molecules"]) {
            txt += `${JSON.stringify(molecule, null, 4)}\n`;
        }
    }
    if (tmpErrorMsg !== "") {
        // Overwrite the error message with the temporary error message if it
        // exists.
        txt = tmpErrorMsg;
        triggerErrorPopup(txt);
    }
}
/**
 * Report an error to the server.
 *
 * @param {string} [errTxt]  The error message. Default is "".
 */
export async function reportErrorToServer(errTxt = "") {
    // Use AJAX (e.g., fetch, Axios, etc.) to send errorData to your PHP server.
    const axios = await dynamicImports.axios.module;
    await axios.post("https://molmoda.org/log_error.php", {
        val: errTxt,
    });
}
/**
 * Trigger an error popup.
 *
 * @param {string}  errTxt            The error message.
 * @param {boolean} [informServer]    Whether to inform the server. Default is
 *                                    true.
 * @param {boolean} [simpleErrorMsg]  Whether to use a simple error message.
 *                                    Default is false.
 */
export function triggerErrorPopup(errTxt, informServer = true, simpleErrorMsg = false) {
    if (tmpErrorMsg !== "") {
        errTxt = tmpErrorMsg;
    }
    if (simpleErrorMsg) {
        errTxt = "TMPERRORMSG:" + errTxt;
    }
    // if (isTest) {
    //     // If it's a test, I want to throw the actual error so I can flag it.
    //     throw new Error(errTxt);
    // }
    pluginsApi.runPlugin("errorreporting", {
        title: "",
        message: errTxt,
        variant: PopupVariant.Danger,
        /**
         * A callback function to report the error to the server.
         */
        callBack: async () => {
            if (informServer) {
                await reportErrorToServer(errTxt);
            }
        },
    });
}
